import React from 'react';

export default function ProtocolStats({ stats }) {
  if (!stats) return null;

  return (
    <>
      <div className="bg-slate-900/60 border border-slate-800 rounded-xl p-4">
        <p className="text-[10px] text-slate-500 uppercase tracking-wider">Active Providers</p>
        <p className="text-2xl font-bold text-white mt-1">{stats.active_providers}</p>
        <p className="text-[10px] text-slate-500 mt-0.5">{stats.total_providers} total registered</p>
      </div>
      <div className="bg-slate-900/60 border border-slate-800 rounded-xl p-4">
        <p className="text-[10px] text-slate-500 uppercase tracking-wider">Tool Calls Settled</p>
        <p className="text-2xl font-bold text-white mt-1">{stats.total_calls_settled?.toLocaleString()}</p>
        <p className="text-[10px] text-slate-500 mt-0.5">
          {stats.source === 'solana-devnet' ? (
            <span className="text-emerald-500">Live from Solana</span>
          ) : (
            `${stats.total_agents || 0} agents`
          )}
        </p>
      </div>
    </>
  );
}
